import { TableRow } from '@mui/material';
import PaddedCell from '../tables/PaddedCell';
import React from 'react';

interface PaddedTableResultsProps {
  isLoading: boolean;
  rowsPerPage: number;
  rowCount: number;
  pageNumber: number;
}

const PaddedTableResults: React.FC<PaddedTableResultsProps> = ({ isLoading, rowCount, rowsPerPage, pageNumber }) => {
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rowCount - pageNumber * rowsPerPage);
  if (!isLoading && rowCount > 0 && emptyRows > 0) {
    return (
      <TableRow style={{ height: 35 * emptyRows }}>
        <PaddedCell colSpan={6} />
      </TableRow>
    );
  }
};

export default PaddedTableResults;
